module.exports = __webpack_public_path__ + "../resources/img/redo.ef0afae9.png";